import { RadioButtonWithLabelOption, TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';

import { Messages } from '../../../../../codegen/Localize';
import { FormikRadioButtonGroup } from '../../../../../commonInfra/components/FormikRadioButtonGroup';
import { HelpService } from '../../../../../commonInfra/services/HelpService';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { learnMoreStyle, settingsRadioButtonItemHeight } from '../../../../styles/CommonStyles';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const EXPLAIN_DATA_SECTION_TEST_ID = 'explain-data-site-setting';
export const EXPLAIN_DATA_LEARN_MORE_TEST_ID = 'explain-data-learn-more';
export const EXPLAIN_DATA_MODE_ENABLED_BUTTON_TEST_ID = 'explain-data-mode-enabled';
export const EXPLAIN_DATA_MODE_DISABLED_BUTTON_TEST_ID = 'explain-data-mode-disabled';


export type ExplainDataSectionProps = SiteSettingsForSiteAdminProps<'explainDataEnabled'>;

export function ExplainDataSection() {

    const buttonList = React.useMemo(() => getButtonListAndClassName(), []);

    if (!FeatureFlags.explainDataSiteControl){
        return null;
      }

  return (
    <SettingsSection
      title={Messages.explainDataSiteSettingTitle()}
      testId={EXPLAIN_DATA_SECTION_TEST_ID}
      description={
        <TextLinkWidget
            className={learnMoreStyle}
            href={HelpService.getServerHelpUrlByCategory('explain-data-site-setting')}
            target='_blank'
            testId={EXPLAIN_DATA_LEARN_MORE_TEST_ID}
          >
          {Messages.learnMore()}
        </TextLinkWidget>
      }
    >
      <FormikRadioButtonGroup
        aria-label={Messages.explainDataSiteSettingTitle()}
        buttonList={buttonList}
        className={settingsRadioButtonItemHeight}
        name={'settings.explainDataEnabled'}
      />
    </SettingsSection>
  );
}


function getButtonListAndClassName(): RadioButtonWithLabelOption<boolean>[] {

  const explainDataEnabledButtonLabel = <>
    <div>{Messages.explainDataEnabled()}</div>
    <div>{Messages.explainDataEnabledDescription()}</div>
  </>;
  const explainDataDisabledButtonLabel = <>
  <div>{Messages.explainDataDisabled()}</div>
  <div>{Messages.explainDataDisabledDescription()}
  </div>
</>;

  return[
    {
      value: true,
      label: explainDataEnabledButtonLabel,
      testId: EXPLAIN_DATA_MODE_ENABLED_BUTTON_TEST_ID
    },
    {
      value: false,
      label: explainDataDisabledButtonLabel,
      testId: EXPLAIN_DATA_MODE_DISABLED_BUTTON_TEST_ID
    }
  ];
}

/* for registering the component in settings registry */
export const ExplainDataSectionSpecs = componentRegistryEntry({
  name: 'ExplainDataSection',
  component: ExplainDataSection
});
